import { Avatar } from '@components/Avatar';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const AvatarSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Avatar"
      description="A circular avatar component for displaying user profile images with a fallback icon state."
      figmaNodeId="808-9932"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Icon Variant (Default)</h3>
      <div className={styles.avatarRow}>
        <Avatar />
        <Avatar variant="icon" />
      </div>
      <p className={styles.hint}>
        Shows the default avatar icon when no image is provided.
      </p>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Image Variant</h3>
      <div className={styles.avatarRow}>
        <Avatar src="https://i.pravatar.cc/32?img=1" alt="User 1" />
        <Avatar src="https://i.pravatar.cc/32?img=2" alt="User 2" />
        <Avatar src="https://i.pravatar.cc/32?img=3" alt="User 3" />
        <Avatar src="https://i.pravatar.cc/32?img=4" alt="User 4" />
      </div>
      <p className={styles.hint}>
        When a <code>src</code> prop is provided, the image is displayed with a subtle border.
      </p>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Comparison</h3>
      <div className={styles.avatarRow}>
        <div className={styles.avatarDemo}>
          <Avatar variant="icon" />
          <span className={styles.avatarLabel}>Icon</span>
        </div>
        <div className={styles.avatarDemo}>
          <Avatar src="https://i.pravatar.cc/32?img=5" alt="Example user" />
          <span className={styles.avatarLabel}>Image</span>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Usage with Custom Alt Text</h3>
      <div className={styles.avatarRow}>
        <Avatar alt="Guest user" />
        <Avatar src="https://i.pravatar.cc/32?img=6" alt="John Doe profile picture" />
      </div>
      <p className={styles.hint}>
        The <code>alt</code> prop provides accessible text for screen readers.
      </p>
    </div>
  </section>
);
